<section class="hr-hero radius4">
  <img [src]="heroImage" [alt]="heroAlt" />
</section>

<section class="hr-plans-wrap" id="plans" *ngIf="plans.length">
  <div class="hr-plans-strip" aria-label="Planes hosting reseller">
    <article class="hr-plan-row radius4" *ngFor="let plan of plans" [ngClass]="plan.colorClass">
      <div class="hr-plan-row__surface">
        <div class="hr-plan-row__grid">
          <div class="hr-plan-row__cell hr-plan-row__cell--plan">
            <span class="hr-plan-row__kicker">Plan</span>
            <span class="hr-plan-row__reseller">RESELLER</span>
            <span class="hr-plan-row__num" aria-hidden="true">{{ plan.diskGb }}</span>
          </div>
          <div class="hr-plan-row__cell hr-plan-row__cell--disk">
            <span class="hr-plan-row__disk-val">{{ plan.diskGb }}GB</span>
            <span class="hr-plan-row__disk-lbl">Espacio Web</span>
          </div>
          <div class="hr-plan-row__cell hr-plan-row__cell--feats">
            <div class="hr-plan-row__feats-inner">
              <span class="hr-plan-row__ilimit">ILIMITADAS</span>
              <ul class="hr-plan-row__feat-list">
                <li>Cuentas cPanel</li>
                <li>Transferencia</li>
                <li>Bases de Datos</li>
              </ul>
            </div>
          </div>
          <div class="hr-plan-row__cell hr-plan-row__cell--contracts">
            <div *ngFor="let c of plan.contracts" class="hr-plan-row__contract-line">
              Contrato {{ contractLabel(c.months) }} — {{ cart.symbol }}{{ c.monthlyPrice | rackeoCurrency }} x Mes
            </div>
          </div>
          <div class="hr-plan-row__cell hr-plan-row__cell--plus">
            <button
              type="button"
              class="hr-plan-row__plus"
              [class.hr-plan-row__plus--open]="isPlanDetailsOpen(plan.id)"
              (click)="togglePlanDetails(plan.id)"
              [attr.aria-expanded]="isPlanDetailsOpen(plan.id)"
              [attr.aria-controls]="'hr-plan-panel-' + plan.id"
              [attr.aria-label]="ariaToggleResellerPlan(plan)">
              +
            </button>
          </div>
          <div class="hr-plan-row__cell hr-plan-row__cell--cta">
            <div class="hr-plan-row__cta-inner">
              <span class="hr-plan-row__desde">Desde/Mensual</span>
              <span class="hr-plan-row__amount"
                >{{ cart.symbol }} {{ plan.fromMonthly | rackeoCurrency
                }}<span *ngIf="cart.currencyHint" class="hr-plan-row__amount-hint"> {{ cart.currencyHint }}</span></span
              >
              <a
                [href]="cart.buildProductUrl(plan)"
                target="_blank"
                rel="noopener noreferrer"
                class="hr-plan-row__comprar"
                [attr.aria-label]="'Comprar ' + plan.name + ' en el carrito'">
                COMPRAR
              </a>
            </div>
          </div>
        </div>
      </div>
      <section
        class="hr-plan-row__panel"
        *ngIf="isPlanDetailsOpen(plan.id)"
        [@hrPlanPanelExpand]
        [id]="'hr-plan-panel-' + plan.id"
        [attr.aria-label]="'Incluido en ' + plan.name">
        <div class="hr-plan-row__panel-body">
          <ul class="hr-plan-row__panel-list">
            <li *ngFor="let b of planBullets">{{ b }}</li>
          </ul>
          <p class="hr-plan-row__panel-cart">
            <a [href]="cart.buildProductUrl(plan)" target="_blank" rel="noopener noreferrer">Comprar en carrito</a>
          </p>
        </div>
      </section>
    </article>
  </div>
</section>

<section class="hr-page-tabs radius4" id="plans_text">
  <div class="tabs-hr-wrap">
    <header class="tabs-hr-head">
      <h1 class="tabs-hr-title">Planes Hosting Reseller</h1>
      <div class="tabs-hr-toolbar">
        <h2 class="tabs-hr-section-title">{{ tabSectionTitles[activeTab] }}</h2>
        <div class="tabs-hr-pills" role="tablist">
          <button
            *ngFor="let label of tabPills; let i = index"
            type="button"
            role="tab"
            [attr.aria-selected]="activeTab === i"
            [class.is-active]="activeTab === i"
            (click)="setTab(i)">
            {{ label }}
          </button>
        </div>
      </div>
    </header>

    <div class="tabs-hr-body" [ngSwitch]="activeTab">
      <div *ngSwitchCase="0" class="tabs-hr-panel hr-panel-gen">
        <div class="hr-generales-layout">
          <div class="hr-features-list">
            <article class="hr-feature-block">
              <img loading="lazy"
                src="assets/images/rackeo/hosting-reseller/generales/generales-ilimitadas.png"
                alt="Ilustración: características ilimitadas en planes reseller" />
              <div>
                <h5>Características ilimitadas</h5>
                <p>
                  En todos nuestros planes te entregamos características ilimitadas: bases de datos, transferencia
                  mensual y cuentas cPanel. Cotiza y compara con tranquilidad.
                </p>
              </div>
            </article>
            <article class="hr-feature-block">
              <img loading="lazy"
                src="assets/images/rackeo/hosting-reseller/generales/generales-control.png"
                alt="Ilustración: control con WHM y cPanel" />
              <div>
                <h5>Control completo</h5>
                <p>
                  Con los paneles <strong>WHM</strong> y <strong>cPanel</strong> podrás crear y administrar tu cuenta y
                  las de tus clientes de forma sencilla y total.
                </p>
              </div>
            </article>
            <article class="hr-feature-block">
              <img loading="lazy"
                src="assets/images/rackeo/hosting-reseller/generales/generales-uptime.png"
                alt="Ilustración: disponibilidad y uptime garantizado" />
              <div>
                <h5>99,9% uptime</h5>
                <p>
                  En Rackeo queremos entregar el mejor servicio; por eso te garantizamos un <strong>99,9% de
                  uptime</strong>.
                </p>
              </div>
            </article>
            <article class="hr-feature-block">
              <img loading="lazy"
                src="assets/images/rackeo/hosting-reseller/generales/generales-soporte.png"
                alt="Ilustración: soporte técnico y atención al cliente" />
              <div>
                <h5>Soporte</h5>
                <p>
                  Contamos con un equipo de expertos atentos a tus consultas. Nuestro objetivo es que cada problema
                  tenga solución.
                </p>
              </div>
            </article>
          </div>
          <div class="hr-generales-aside">
            <img loading="lazy"
              src="assets/images/rackeo/hosting-reseller/generales/generales-negocio.png"
              alt="Comienza tu propio negocio de hosting reseller" />
            <div class="hr-aside-card">
              <h5>Comienza tu propio negocio</h5>
              <p>
                Si quieres ser revendedor de hosting, Rackeo te ofrece planes competitivos, WHM/cPanel y la
                infraestructura lista para que vendas sin preocuparte del servidor.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div *ngSwitchCase="1" class="tabs-hr-panel hr-panel-carac">
        <div class="hr-features-list hr-features-carac">
          <article class="hr-feature-block">
            <img loading="lazy"
              src="assets/images/rackeo/hosting-reseller/caracteristicas/caracteristicas-programacion.png"
              alt="Icono: programación y entornos de desarrollo" />
            <div>
              <h5>Programación</h5>
              <p>
                Soporta MySQL Base de Datos con Acceso phpMyAdmin, PostgreSQL acceso phpPgAdmin tambien Lenguajes de Programación: CGI, Fast CGI, PHP 5, Ruby on Rails, Perl, Python, SSI, Flash además de Modelos de Programación: Curl, CPAN, GD Library, ImageMagick. Cron Job y Extensiones FrontPage
              </p>
            </div>
          </article>
          <article class="hr-feature-block">
            <img loading="lazy"
              src="assets/images/rackeo/hosting-reseller/caracteristicas/caracteristicas-site-publisher.png"
              alt="Icono: Site Publisher para crear sitios en minutos" />
            <div>
              <h5>Site Publisher</h5>
              <p>
                Dale un valor agregado a tus planes entregarle a tus clientes el increíble Site Publisher una poderosa herramienta con la cual podrán crear sitios en minutos sin necesidad de tener conocimientos avanzados en programación
              </p>
            </div>
          </article>
          <article class="hr-feature-block">
            <img loading="lazy"
              src="assets/images/rackeo/hosting-reseller/caracteristicas/caracteristicas-softaculous.png"
              alt="Icono: Softaculous, instalador de scripts" />
            <div>
              <h5>Softaculous</h5>
              <p>
                Gratis con todos los planes reseller te entregamos SOFTACULOUS que contiene más de 100 scripts en las cuales incluyen como sistemas de gestión de contenido, herramientas para la creación de blog, atención al cliente, foros de discusión, comercio electrónico, galería de imágenes, Administración de anuncios, Buscadores, Administración de proyectos, entrenamiento electrónico, encuestas avanzadas, etc
              </p>
            </div>
          </article>
          <article class="hr-feature-block">
            <img loading="lazy"
              src="assets/images/rackeo/hosting-reseller/caracteristicas/caracteristicas-whm.png"
              alt="Icono: panel WHM para revendedores" />
            <div>
              <h5>WHM</h5>
              <p>
                Este panel de control administrar y gestionar completamente las distintas cuentas de Hosting que genere para sus clientes. De esta forma, te ofrecemos la posibilidad de actuar como una pequeña empresa de hosting, con la gran ventaja de que no tendrás que preocupar de la configuración, mantenimiento, actualización y administración de los servidores.
              </p>
            </div>
          </article>
        </div>
      </div>

      <div *ngSwitchCase="2" class="tabs-hr-panel hr-panel-cmp">
        <div class="hr-table-scroll">
          <table class="hr-comparison-table">
            <thead>
              <tr>
                <th scope="col"><span>Característica</span></th>
                <th scope="col"></th>
                <th scope="col" *ngFor="let plan of plans" [ngClass]="plan.colorClass">{{ plan.name }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of comparisonRows" [class.hr-comparison-section]="row.section">
                <ng-container *ngIf="row.section">
                  <td [attr.colspan]="comparisonTableColspan()" class="hr-comparison-section-title">{{ row.section }}</td>
                </ng-container>
                <ng-container *ngIf="row.feature && row.v">
                  <td class="hr-comparison-feature">{{ row.feature }}</td>
                  <td class="hr-comparison-help">
                    <span *ngIf="row.helpText" class="hr-help" [attr.title]="row.helpText">
                      <img loading="lazy" src="assets/images/rackeo/shared/ui/ui-icono-ayuda.png" alt="Más información" />
                    </span>
                  </td>
                  <td *ngFor="let cell of row.v" class="hr-comparison-value">
                    <img loading="lazy"
                      *ngIf="cell === 'check'"
                      src="assets/images/rackeo/shared/ui/ui-icono-check.png"
                      alt="Incluido" />
                    <span *ngIf="cell !== 'check'">{{ cell }}</span>
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>

        <hr class="hr-divider" />

        <div class="hr-table-scroll" *ngIf="comparisonPrices.length">
          <table class="hr-comparison-prices">
            <thead>
              <tr>
                <th scope="col">Precios</th>
                <th scope="col" *ngFor="let plan of plans" [ngClass]="plan.colorClass">
                  {{ plan.name }}<br /><small>{{ plan.diskGb }} GB</small>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let pr of comparisonPrices">
                <td class="hr-price-label">{{ pr.label }}</td>
                <td>{{ cart.symbol }} {{ pr.plan1 }} x Mes</td>
                <td>{{ cart.symbol }} {{ pr.plan2 }} x Mes</td>
                <td>{{ cart.symbol }} {{ pr.plan3 }} x Mes</td>
                <td>{{ cart.symbol }} {{ pr.plan4 }} x Mes</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td></td>
                <td *ngFor="let plan of plans">
                  <a
                    [href]="cart.buildProductUrl(plan)"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="hr-btn-comprar">
                    Comprar
                  </a>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="hr-cta-ayuda">
  <app-rackeo-cta-contact></app-rackeo-cta-contact>
</section>
